




















































import { Component, Prop, Vue } from 'vue-property-decorator';
import { mapGetters, mapActions } from 'vuex';

import Button, { ButtonSize } from '@/modules/shared/components/button.component.vue';
import Icon, { IconEnum } from '@/modules/shared/components/icon.component.vue';
import RewardCartLine from '@/modules/shared/components/reward-cart-line.component.vue';

import textDecorate from '@/modules/shared/directives/text-decorate.directive.ts';


@Component({
  components: {
    Button,
    Icon,
    RewardCartLine,
  },
  computed: {
    ...mapGetters({
      catalogUrls: 'getCatalogUrls',
      cartLines: 'getRewardCartLines',
      rewardCartHasLines: 'rewardCartHasLines',
    }),
  },
  directives: {
    textDecorate,
  },
})
export default class RewardCartNavbar extends Vue {
  @Prop({ default: false }) private isOpen!: boolean;


  private buttonSize = ButtonSize;
  private iconEnum =  IconEnum;
  private cartLines!: any;
  private rewardCartHasLines!: any;


  private closeMenu(): void {
    this.$emit('close-menu');
  }

  private removeCartLine(lineId: string) {
    this.$store.commit('removeRewardCartLine', lineId);
  }

  private order(): void {
    if ( this.rewardCartHasLines ) {
      this.$emit('order');
    }
  }

}
